<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="main/currency/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="false"
            :canEdit="canEdit"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="CurrencyForm"
        >
          <template #header-btns>
            <button
                @click="goToProductPage(item.id)"
                v-if="item.id"
                class=" float-left px-2 text-white py-1 rounded-lg text-[8px] font-bold shadow-md transition-all duration-300 transform hover:scale-105  bg-gradient-to-r from-blue-800 via-blue-900 to-blue-700 hover:bg-[#F17359]"        >
              مشاهده محصولات
            </button>
          </template>

          <template>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <v-text-field label="* نام ارز "
                            v-model="item.name" background-color="white" class="rounded-lg"
                            :disabled="!isEditing"/>

              <money label="* ضریب تبدیل به تومان "
                     v-model="item.exchange_rate_to_toman" background-color="white" class="rounded-lg"
                     :disabled="!isEditing || recalcInProgress"
                     :hint="recalcInProgress ? 'تا پایان بروزرسانی قیمت محصولات با نرخ فعلی، امکان ثبت نرخ جدید نیست' : ''"
                     :persistent-hint="recalcInProgress"/>
            </div>

            <div v-if="item.id" class="mt-4 rounded-xl border overflow-hidden"
                 :class="recalcCardBorderClass">
              <div class="px-4 py-3 flex flex-wrap items-center justify-between gap-2" :class="recalcCardHeaderClass">
                <div class="flex items-center gap-2">
                  <span class="w-2.5 h-2.5 rounded-full" :class="[recalcDotClass, {'animate-pulse': recalcInProgress}]"></span>
                  <span class="text-sm font-bold text-gray-700">بروزرسانی قیمت محصولات با این نرخ</span>
                </div>
                <span class="text-xs font-semibold px-2 py-1 rounded-full" :class="recalcBadgeClass">
                  {{ recalcStatusLabel }}
                </span>
              </div>

              <div class="px-4 py-3 bg-white">
                <template v-if="recalcStatus === 'running'">
                  <div class="flex items-center justify-between text-xs text-gray-600 mb-1.5">
                    <span>{{ item.price_recalc_processed || 0 }} از {{ item.price_recalc_total || 0 }} محصول</span>
                    <span class="font-bold">{{ recalcPercent }}٪</span>
                  </div>
                  <div class="w-full h-2.5 rounded-full bg-gray-200 overflow-hidden">
                    <div class="h-full rounded-full bg-blue-500 transition-all duration-500 ease-out"
                         :style="{ width: recalcPercent + '%' }"></div>
                  </div>
                  <div v-if="item.price_recalc_error" class="mt-2 text-xs text-amber-700 bg-amber-50 rounded-lg px-2 py-1.5 break-words">
                    {{ item.price_recalc_error }}
                  </div>
                  <div class="mt-2 text-xs text-gray-500">
                    نیازی به ماندن در این صفحه نیست؛ هر وقت برگردید آخرین وضعیت را می‌بینید. اگر پردازش روی یک محصول با
                    خطا مواجه شود، ابتدا چند بار دوباره تلاش می‌شود و در صورت عدم موفقیت، تمام تغییرات و نرخ ارز به‌طور
                    خودکار به حالت قبل بازمی‌گردد.
                  </div>
                </template>

                <template v-else-if="recalcStatus === 'failed'">
                  <div class="text-sm text-red-700">
                    بروزرسانی با خطا متوقف شد{{ item.price_recalc_error ? ':' : '.' }}
                  </div>
                  <div v-if="item.price_recalc_error" class="mt-1 text-xs text-red-600 break-words">
                    {{ item.price_recalc_error }}
                  </div>
                </template>

                <template v-else-if="recalcStatus === 'done'">
                  <div class="text-sm text-green-700">
                    قیمت همه محصولات این ارز با نرخ فعلی بروزرسانی شده است.
                  </div>
                  <div v-if="item.price_recalc_error" class="mt-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-2 break-words">
                    {{ item.price_recalc_error }}
                  </div>
                </template>

                <template v-else>
                  <div class="text-sm text-gray-500">بروزرسانی‌ای برای این ارز ثبت نشده است.</div>
                </template>
              </div>
            </div>
          </template>

          <template #item.price_recalc_status="{ item: row }">
            <span class="text-xs font-semibold px-2 py-1 rounded-full" :class="statusBadgeClass(row.price_recalc_status)">
              {{ statusLabel(row.price_recalc_status) }}
            </span>
          </template>
        </m-form>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";


export default {
  name: "Currency",
  mixins: [MFormMixin,  formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'main/currency/all',
      baseUrl: "main/currency",
      permissionBasename: "currency",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      factors: [],
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      recalcPollTimer: null,
      cols: [
        {
          text: "نام ارز",
          value: "name",
        },
        {
          text: "ضریب تبدیل به تومان",
          value: "exchange_rate_to_toman",
          type: 'numeric'
        },
        {
          text: "وضعیت بروزرسانی قیمت",
          value: "price_recalc_status",
        },
      ],

    };
  },
  computed: {
    title(){
      return 'ارز'
    },
    headers() {
      return [];
    },
    canEdit() {
      if (this.item.id && this.item.is_auto_created) return false;
      return !this.recalcInProgress;
    },
    recalcStatus() {
      return this.item.price_recalc_status || 'idle';
    },
    recalcInProgress() {
      return this.recalcStatus === 'running';
    },
    recalcPercent() {
      const total = this.item.price_recalc_total || 0;
      const processed = this.item.price_recalc_processed || 0;
      if (!total) return this.recalcStatus === 'done' ? 100 : 0;
      return Math.min(100, Math.round((processed / total) * 100));
    },
    recalcStatusLabel() {
      return this.statusLabel(this.recalcStatus);
    },
    recalcBadgeClass() {
      return this.statusBadgeClass(this.recalcStatus);
    },
    recalcDotClass() {
      return {
        running: 'bg-blue-500',
        done: 'bg-green-500',
        failed: 'bg-red-500',
        idle: 'bg-gray-400',
      }[this.recalcStatus];
    },
    recalcCardBorderClass() {
      return {
        running: 'border-blue-200',
        done: 'border-green-200',
        failed: 'border-red-200',
        idle: 'border-gray-200',
      }[this.recalcStatus];
    },
    recalcCardHeaderClass() {
      return {
        running: 'bg-blue-50',
        done: 'bg-green-50',
        failed: 'bg-red-50',
        idle: 'bg-gray-50',
      }[this.recalcStatus];
    },
  },
  watch: {
    'item.id'(newId) {
      this.stopRecalcPolling();
      if (newId) this.pollRecalcStatus();
    },
  },
  mounted() {
    if (this.item.id) this.pollRecalcStatus();
  },
  beforeDestroy() {
    this.stopRecalcPolling();
  },
  updated() {
  },
  methods: {
    goToProductPage(id) {
      this.$router.push(`/panel/adminProductList?currency=${id}`)
    },
    statusLabel(status) {
      return {
        running: 'در حال بروزرسانی',
        done: 'بروزرسانی شده',
        failed: 'خطا در بروزرسانی',
        idle: 'بدون بروزرسانی',
      }[status] || 'بدون بروزرسانی';
    },
    statusBadgeClass(status) {
      return {
        running: 'bg-blue-100 text-blue-700',
        done: 'bg-green-100 text-green-700',
        failed: 'bg-red-100 text-red-700',
        idle: 'bg-gray-100 text-gray-600',
      }[status] || 'bg-gray-100 text-gray-600';
    },
    submit(clearForm) {
      MFormMixin.methods.submit.call(this, clearForm);
      this.stopRecalcPolling();
      setTimeout(() => this.pollRecalcStatus(), 800);
    },
    pollRecalcStatus() {
      if (!this.item.id) return;
      this.request({
        url: this.endpoint(`${this.baseUrl}/${this.item.id}`),
        method: 'get',
        loading: false,
        success: (data) => {
          if (this.item.id !== data.id) return;
          this.$set(this.item, 'price_recalc_status', data.price_recalc_status);
          this.$set(this.item, 'price_recalc_total', data.price_recalc_total);
          this.$set(this.item, 'price_recalc_processed', data.price_recalc_processed);
          this.$set(this.item, 'price_recalc_error', data.price_recalc_error);
          this.$set(this.item, 'price_recalc_finished_at', data.price_recalc_finished_at);
          // a failed run rolls the rate back on the server; reflect that here too
          // so the field doesn't keep showing the rejected value the admin typed
          this.$set(this.item, 'exchange_rate_to_toman', data.exchange_rate_to_toman);

          if (data.price_recalc_status === 'running') {
            this.recalcPollTimer = setTimeout(this.pollRecalcStatus, 2000);
          }
        },
        error: () => {
          this.recalcPollTimer = setTimeout(this.pollRecalcStatus, 5000);
        },
      });
    },
    stopRecalcPolling() {
      if (this.recalcPollTimer) {
        clearTimeout(this.recalcPollTimer);
        this.recalcPollTimer = null;
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>

